export default {
    "timestamp": {
        "date": "2021-04-13 12:56:02.643436", "timezone_type": 3, "timezone": "Asia\/Jakarta"
    },
    "environment": "local",
    "data": {
        "query": {
            "take": 10, 
            "orderBy.created_at": "desc", 
            "skip": 0, 
            "with.total": true
        },
        "debug": {
            "sql": "select `portal_news`.`id` as `news.id`, `portal_news`.`title` as `news.title`, `portal_news`.`tag` as `news.tag`, `portal_news`.`content` as `news.content`, `portal_news`.`images` as `news.images`, `portal_news`.`category_id` as `news.category_id`, `portal_news`.`title` as `news.title`, `portal_news`.`published` as `news.published`, `portal_news`.`progress_status` as `news.progress_status`, `portal_news`.`viewer_count` as `news.viewer_count`, `portal_news`.`status` as `news.status`, `portal_news`.`likes` as `news.likes`, `portal_news`.`created_by` as `news.created_by`, `portal_news`.`published_at` as `news.published_at`, `portal_news`.`created_at` as `news.created_at`, `portal_news`.`updated_at` as `news.updated_at` from `portal_news` order by `created_at` desc limit 10 offset 0", "bindings": []
        },
        "total": 538,
        "show": 10,
        "records": [
            {
                "id": 593, 
                "code": "20399403", 
                "product": "Go Presence", 
                "category": "NW & Infra Service",
                "division": "-",
                "status": "approve",
                "publish": 1,
                "created_at": "2021-04-08T03:28:13.000000Z", 
                "updated_at": "2021-04-08T03:28:13.000000Z", 
            },
            {
                "id": 593, 
                "code": "20399404", 
                "product": "iFleet", 
                "category": "-",
                "division": "-",
                "status": "retire",
                "publish": 0,
                "created_at": "2021-04-08T03:28:13.000000Z", 
                "updated_at": "2021-04-08T03:28:13.000000Z", 
            },
            {
                "id": 593, 
                "code": "20399405", 
                "product": "Telkom Unicall", 
                "category": "-",
                "division": "DSS",
                "status": "submitter",
                "publish": 0,
                "created_at": "2021-04-08T03:28:13.000000Z", 
                "updated_at": "2021-04-08T03:28:13.000000Z", 
            },

        ]
    },
    "response": {
        "code": 200, 
        "description": "OK"
    },

    "account": {
        "me": {
            "id": 292, 
            "NIK": null, 
            "name": "deggan", 
            "email": "", 
            "user_role": 2, 
            "username": "deggan", 
            "role": "admin"
        }
    }
}